<template>
  <div ref="homeUl" class="wrongQuestionBook edit-style detail">
    <!-- {{ apiData }} -->
    <!-- {{ searchData }} -->
    <!-- {{ $store.state }} -->
    <!-- {{ questionList.length }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p class="title">错题本</p>
      <div class="hidden-box"></div>
      <!-- <img src="@/assets/learning/setting.png" alt="" @click="toSetting" /> -->
    </div>
    <div class="muen-box">
      <div @click="showGrade = true">
        <span>{{ isCorrectVal }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div @click="showSubject = true">
        <span>{{ subjectVal }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div @click="difficultyType = true">
        <span>{{ difficultyVal }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div @click="showYear = true">
        <span>{{ timeVal }}</span>
        <van-icon name="arrow-down" />
      </div>
    </div>
    <div class="question-list-box">
      <div
        v-for="(v, i) in questionList"
        :key="i"
        class="question-list"
        @click="linkTo(v)"
      >
        <div class="question-list-top">
          <span class="number">{{ 10 > i + 1 ? "0" + (i + 1) : i + 1 }}</span>
          <span class="name">{{ v.source }}</span>
          <span>{{ v.difficulty | setName(difficultyList) }}</span>
        </div>
        <div class="qusetion-box" v-html="v.question"></div>
      </div>
      <div class="loading-box">
        <van-loading v-if="current < pages" size="24px">加载中...</van-loading>
        <van-divider v-else dashed>没有找到更多了</van-divider>
      </div>
    </div>

    <van-popup v-model="showGrade" round position="bottom">
      <van-picker
        show-toolbar
        :columns="isCorrectList"
        @cancel="showGrade = false"
        @confirm="onConfirmGrade"
      />
    </van-popup>
    <van-popup v-model="showSubject" round position="bottom">
      <van-picker
        show-toolbar
        :columns="subjectList"
        @cancel="showSubject = false"
        @confirm="onConfirmSubject"
      />
    </van-popup>
    <van-popup v-model="difficultyType" round position="bottom">
      <van-picker
        show-toolbar
        :columns="orderByList"
        @cancel="difficultyType = false"
        @confirm="onConfirmExamType"
      />
    </van-popup>
    <van-popup v-model="showYear" round position="bottom">
      <van-picker
        show-toolbar
        :columns="yearList"
        @cancel="showYear = false"
        @confirm="onConfirmYear"
      />
    </van-popup>
  </div>
</template>

<script>
const isCorrectList = ["全部", "未订正", "已订正"];
const orderByList = ["默认排序", "难题优先", "简单优先"];
import { subjectOptions, difficultyList, optionsTime } from "@/util/constdata";
import { questionPage } from "@/api/interface";
export default {
  name: "WrongQuestionBook",
  data() {
    return {
      listLoading: true,
      isCorrectList: isCorrectList,
      orderByList: orderByList,
      showGrade: false,
      gradeOption: [],
      // typeList: [],
      showSubject: false,
      difficultyOption: difficultyList,
      optionsTime: optionsTime,
      difficultyList: [],
      subjectOptions: subjectOptions,
      subjectList: [],
      difficultyVal: "难度排序",
      gradetypecount: [],
      difficultyType: false,
      yearList: [],
      showYear: false,
      isCorrectVal: "全部",
      subjectVal: "",
      timeVal: "所有",
      searchData: {
        current: 1,
        size: 10,
        sortType: 3,
        // token: "c38cca81-07eb-4283-80b5-0c13cb9541b6",
        // schoolID: 29,
        // studentId: 115985
      },
      level: 3,
      questionList: [],
      current: 1,
      pages: 2,
      apiData: {},
      // key: 0
    };
  },
  // created() {
  // this.initSeaechData();
  //   this.initOption();
  //   // this.getList();
  //
  // },
  created() {
    this.getPhoneType();
  },
  mounted() {
    // 判断是否在web端打开
    let type = this.$route.query.isWeb;
    if (type) {
      this.$store.commit("setToken", this.$route.query.token);
      this.$store.commit("setSchoolId", this.$route.query.schoolID);
      this.apiData = this.$route.query;
      this.initOption();
      this.initSeaechData();
    } else {
      window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.initMobile();
    }

    // window.addEventListener("scroll", this.disposeScroll); //监听滚动条
  },
  beforeDestroy() {
    //离开
    window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
  },
  methods: {
    getPhoneType() {
      let u = navigator.userAgent;
      // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    downWindow() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 3,
        });
      } else {
        window.mobile.hideTitleBar();
      }
    },
    goBackView() {
      this.downView();
    },
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", this.apiData.token);
      this.$store.commit("setSchoolId", this.apiData.schoolID);
      if (!this.apiData.levelID) {
        this.apiData.levelID = 3;
      }
      this.initSeaechData();
      this.initOption();
      this.downWindow();
    },
    linkTo(v) {
      this.$store.commit("setWorngData", v);
      this.$router.push({
        name: "WrongQuestion",
      });
    },
    disposeScroll() {
      if (this.page > this.pages) {
        return;
      } // 如果当前大于总页数，也就是最后一页，那么就不不触发了
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0; // 获取滚动条垂直的位置
      if (document.body.clientHeight - top - window.innerHeight < 20) {
        this.current++;
        this.initSeaechData();
        //如果滚动条的位置加上窗口的高度大于可见的窗口可见的高度，那么也就是滚动条到低了
        // this.$emit('update') // 执行update方法
      }
    },
    // 逻辑判断 处理搜索字段
    initSeaechData() {
      this.searchData.current = this.current;
      // this.searchData.token = this.apiData.token;
      // this.searchData.schoolID = this.apiData.schoolID;
      this.searchData.studentId = this.apiData.studentID;
      this.searchData.gradeId = this.apiData.gradeId;
      this.subjectOptions.forEach((index) => {
        if (this.subjectVal == index.label) {
          this.searchData.subjectId = index.value;
        }
      });
      if (!this.searchData.subjectId) {
        this.searchData.subjectId = 1;
      }
      if (this.difficultyVal == "难题优先") {
        this.searchData.sortOrder = 2;
      }
      if (this.difficultyVal == "简单优先") {
        this.searchData.sortOrder = 1;
      }
      if (
        this.difficultyVal == "难度排序" ||
        this.difficultyVal == "默认排序"
      ) {
        this.searchData.sortOrder = 1;
      }

      if (this.isCorrectVal == "未订正") {
        this.searchData.isCorrect = 0;
      }
      if (this.isCorrectVal == "已订正") {
        this.searchData.isCorrect = 1;
      }
      if (this.isCorrectVal == "全部") {
        this.searchData.isCorrect = 2;
      }

      this.optionsTime.forEach((index) => {
        if (index.label == this.timeVal) {
          this.searchData.timeRange = index.value;
        }
      });
      this.getList();
    },
    getList() {
      // let data = {
      //   studentId: 115985,
      //   isCorrect: 2,
      //   orderBy: 2,
      //   current: 1,
      //   size: 10,
      //   subjectId: 2,
      //   timeRange: 0,
      //   // gradeId: 500,
      //   token: "c38cca81-07eb-4283-80b5-0c13cb9541b6",
      //   schoolID: 29
      // };
      questionPage(this.searchData).then((res) => {
        // this.listLoading = false;
        if (this.current > 1) {
          this.questionList = this.questionList.concat(res.data.records);
        } else {
          window.addEventListener("scroll", this.disposeScroll); //监听滚动条
          this.questionList = res.data.records;
          this.pages = res.data.pages;
        }
      });
    },
    initOption() {
      //初始化年级 科目列表
      let level = this.apiData.levelID;
      // this.typeList.push("已订正", "未订正");
      // this.subjectList.push("全部");
      this.difficultyList.push("全部");

      if (level != 3) {
        this.subjectOptions.map((index) => {
          if (index.value == 6) {
            index.label = "道德与法治";
          }
        });
      }
      this.subjectOptions.forEach((index) => {
        this.subjectList.push(index.label);
      });
      this.subjectVal = this.subjectList[0];
      //考试类型所有列表
      this.difficultyOption.forEach((index) => {
        this.difficultyList.push(index.label);
      });

      //年份
      // console.log(this.difficultyList);
      this.optionsTime.forEach((index) => {
        this.yearList.push(index.label);
      });
    },
    onConfirmYear(val) {
      this.current = 1;
      this.pages = 2;
      this.timeVal = val;
      this.showYear = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    onConfirmGrade(val) {
      this.current = 1;
      this.pages = 2;
      this.isCorrectVal = val;
      this.showGrade = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    onConfirmExamType(val) {
      this.current = 1;
      this.pages = 2;
      this.difficultyVal = val;
      this.difficultyType = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    onConfirmSubject(val) {
      this.current = 1;
      this.pages = 2;
      this.subjectVal = val;
      this.showSubject = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    downView() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 1,
        });
      } else {
        window.mobile.closeMobileUI();
      }
    },
  },
};
</script>
<style lang="scss">
.wrongQuestionBook {
  img {
    max-width: 100%;
    height: auto !important;
  }
}
</style>
<style scoped lang="scss">
.wrongQuestionBook {
  background-color: rgba(0, 0, 0, 0.04);
  min-height: 100vh;
  // margin-top: 87px;

  padding-top: 87px;

  .paper-list-box {
    padding: 24px;
    div {
      font-size: 12px;
    }
    .paper-list-cnt {
      color: rgba(0, 0, 0, 0.5);
      margin: 9px 0;
      span {
        margin-right: 8px;
      }
    }
    .paper-list-time {
      span {
        margin-right: 6px;
        color: rgba(0, 0, 0, 0.5);
      }
      .time {
        color: rgba(33, 150, 243, 100);
      }
    }
    .paper-list {
      padding: 12px;
      margin-bottom: 12px;
      border-radius: 4px;
      overflow: hidden;
      background-color: white;
      position: relative;
      .tips {
        position: absolute;
        top: 0;
        right: 0;
        padding: 3px 12px;
        border-radius: 0 0 0 4px;
        color: #ffffff;
      }
      .one-color {
        background-color: rgba(255, 171, 0, 100);
      }
      .two-color {
        background-color: rgba(11, 170, 142, 100);
      }
      .three-color {
        background-color: rgba(16, 198, 148, 100);
      }
      .four-color {
        background-color: rgba(233, 148, 20, 100);
      }
      .five-color {
        background-color: rgba(232, 210, 24, 100);
      }
      p {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .question-list-box {
    padding: 12px;
    .loading-box {
      text-align: center;
    }
    .question-list-top {
      margin-bottom: 6px;
      span {
        margin-right: 6px;
        vertical-align: middle;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
      }
      .number {
        padding: 2px 3px;
        background-color: #7b9cc7;
        border-radius: 50%;
        color: #ffffff;
      }
      .name {
        color: #7b9cc7;
      }
    }
    .question-list {
      padding: 12px;
      background-color: #ffffff;
      border-radius: 4px;
      overflow: hidden;
      margin-bottom: 12px;
    }
    .qusetion-box {
      // height: 40px;
      overflow: hidden;
    }
  }
  .muen-box {
    padding: 0 24px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    position: fixed;
    width: 100%;
    left: 0;
    top: 44px;
    z-index: 10;
    div {
      padding: 12px 0;
      i {
        font-size: 14px;
        margin-left: 4px;
        color: rgba(0, 0, 0, 0.3);
        vertical-align: middle;
      }
    }
  }
}
</style>
